<template>
  <div>
    <div class="modal fade" id="changeStatusModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień datę dostawy wybranych wierszy zamówienia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>

<div class="col-md-4 mb-3">
  <label>Globalna data dostawy:</label>

  <input
    type="date"
    class="form-control form-control-sm"
    v-model="globalDeliveryDate"
    @change="applyGlobalDeliveryDate"
  >
</div>
			
            <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr zam.</th>
                  <th>Nr poz.</th>
                  <th>Podzespół nr rysunku</th>
                  <th>Nr katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Ilość zamawiana</th>
                  <th>Ilość dostarczona</th>
                  <th>Ilość wydana</th>
                  <th>Status</th>
                  <th>Data dostawy</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in selectedRecords" :class="{ 'text-muted text-decoration-line-through': isCancelled(record) }">
                  <td>{{ record.order_list?.order_number ?? '' }}</td>
                  <td>{{ record.id }}</td>
                  <td>{{ record.subteam_drawing_no }}</td>
                  <td>{{ record.article?.catalog_number || '' }}</td>
                  <td>{{ record.article?.model }}</td>
                  <td>{{ record.article?.description }}</td>
                  <td>{{ record.quantity_required }}</td>
                  <td>
				    <template
                        <template v-if="['Zamówienie wysłane', 'Częściowo zrealizowane', 'Zrealizowane'].includes(newSelectedStatusName) && !isCancelled(record)">
                      <input
                          type="number"
                          step="0.01"
                          class="form-control form-control-sm"
                          v-model.number="record.delivered_quantity"
                          :max="record.delivered_quantity"
                          style="max-width: 100px"
                      />
                    </template>
                    <template v-else>
                      {{ record.delivered_quantity }}
                    </template>
				  </td>
                  <td>{{ record.dispatched_quantity }}</td>
                  <td>{{ record.status?.name ?? record.status ?? '' }}</td>
<td>
  <input
    type="date"
    class="form-control form-control-sm"
    v-model="record.delivery_date_deadline"
  >
</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from "bootstrap";
import { router } from '@inertiajs/vue3';

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  computed: {
    newSelectedStatusName() {
      const selected = this.statuses.find(s => s.id === Number(this.newSelectedStatus));
      return selected ? selected.name : '';
    },
	
  groupedOrders() {
    const groups = {};

    (this.selectedRecords || []).forEach(record => {
      const orderNo = record.order_list?.order_number ?? 'BRAK';

      if (!groups[orderNo]) {
        groups[orderNo] = {
          order_number: orderNo,
          records: []
        };
      }

      groups[orderNo].records.push(record);
    });

    return Object.values(groups);
  }
  },
  props: {
    selectedRecords: Array,
    statuses: Object
  },

  watch: {
selectedRecords:{
 handler(newVal){
  if(newVal&&newVal.length){
   this.originalDeliveryDates={};
   let dates=[];
   newVal.forEach(record=>{
    let date=record.order_list?.order_list_items?.find(item=>item.id===record.id)?.delivery_date_deadline??null;
    this.originalDeliveryDates[record.id]=date;
    record.delivery_date_deadline=date;
    dates.push(date);
   });
   let unique=[...new Set(dates)];
   this.globalDeliveryDate=unique.length===1?unique[0]:null;
  }
 },
 immediate:true
}
  },

  data() {
    return {
      error: null,
	  globalDeliveryDate: null,
	  originalDeliveryDates: {},
      originalDeliveredQuantities: {},
	  expandedOrders: {} 
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
		  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  methods: {
	applyGlobalDeliveryDate(){
	this.selectedRecords.forEach(record=>{
	record.delivery_date_deadline = this.globalDeliveryDate;
 });
},

isCancelled(record) {
  const statusName = record.status?.name ?? record.status ?? '';
  return statusName === 'Anulowane';
},

async submitForm(){
  const records = this.selectedRecords
    .filter(record => {
      const oldDate = this.originalDeliveryDates[record.id];
      return oldDate !== record.delivery_date_deadline;
    })
    .map(record => ({
      id: record.id,
      delivery_date_deadline: record.delivery_date_deadline
    }));
  if(!records.length){
    this.error = "Nie zmieniono żadnej daty.";
    return;
  }
  axios.post(route('quoteRequests.change-delivery-date'), {
    records
  })
  .then(() => {
    this.$emit('added-success','Zmieniono daty dostawy poprawnie');
    this.$emit('updated-article', true);
    this.$emit('clear-selection');
    this.hide();
  })
  .catch(error => {
    this.error = error.response?.data ?? 'Błąd zapisu';
    console.log(error);
  });
},

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>
